
<div class="container">
  <div class="row">
    <div class="col-sm-12">
      <h2>Users</h2>
      <error [error]="error"></error>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <div class="table-card">
        <list-controls [search]="searchText" [limit]="pageSize" [page]="currentPage" [numPages]="maxPages" [totalCount]="totalCount" (onChange)="onListControlsChange($event)"><a class="btn btn-primary" [href]="'/#/user-edit'" *ngIf="isAllowedToEditUsers">Create User</a></list-controls>
        <table class="table table-responsive">
          <thead>
            <tr class="table-header-with-controls">
              <th>Name</th>
              <th>Email</th>
              <th>Roles</th>
              <th>Projects</th>
              <th *ngIf="showSwitchColumn">Switch</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let user of users">
              <td>{{user.firstName}} {{user.lastName}}</td>
              <td>{{user.emailAddress}}</td>
              <td>{{user.roles}}</td>
              <td>
                <list-of-text [itemList]="user.projectArray" [limit]="5"></list-of-text>
              </td>
              <td *ngIf="showSwitchColumn"><a href="javascript:void(0);" (click)="switchUser(user.id)" [hidden]="!user.canSwitch">Log In</a></td>
              <td *ngIf="isAllowedToEditUsers"><a href="#/user-edit?id={{user.id}}"><span class="oi oi-pencil"></span><span> Edit</span></a></td>
            </tr>
            <tr *ngIf="users.length === 0">
              <td colspan="6">
                <p class="text-center empty-table-message">There are no users to display.</p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>